






























































import Vue from "vue";
import Component from "vue-class-component";
import {
  UserAccountDto,
  FindAllAccountsQuery
} from "@/api/AuthenticationApiClient";
import ApiFactory from "../../api/ApiFactory";
import AlertService from "../../services/alert.service";

@Component({
  name: "Accounts"
})
export default class Accounts extends Vue {
  private alerService = new AlertService();
  private accounts: UserAccountDto[] = [];

  created() {
    this.loadAccounts();
  }

  loadAccounts() {
    const apiClient = ApiFactory.CreateAuthClient();
    const query = new FindAllAccountsQuery();
    apiClient
      .users_Accounts(query)
      .then(result => {
        if (result) {
          this.accounts = result;
        } else {
          this.accounts = [];
        }
      })
      .catch(error => {
        this.alerService.error("Accounts", "Error retrieving Acounts");
      });
  }
}
